export const isWebview = () => {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') {
    return false
  }

  try {
    const params = new URLSearchParams(window.location.search)
    if (params.get('webview') === 'true') return true
  } catch (_) {
    console.info('[isWebview] URLSearchParams not available, ignoring.')
  }
  if (window.ReactNativeWebView) return true

  const ua = (navigator.userAgent || navigator.vendor || '').toLowerCase()
  if (!ua) return false

  const isAndroidWebview = /; wv\)/.test(ua) || ua.includes('webview')

  const isIos = /iphone|ipod|ipad/.test(ua)
  const isIosWebview =
    isIos &&
    ua.includes('applewebkit') &&
    ua.includes('mobile') &&
    !ua.includes('safari') &&
    !/crios|fxios|edgios/.test(ua)

  return isAndroidWebview || isIosWebview
}

export default isWebview
